// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1_W6_","title":"styles_title__2piSg","paragraph_container":"styles_paragraph_container__n0hGO","paragraph":"styles_paragraph__1vwsm"};